import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { NgxSpinnerService } from "ngx-spinner";

import { NavigatorService } from '../../../../services/navigator';
import { PatientService } from '../../../../services/patient.service';
import {BasicAgency, BasicUser, RestApiService} from '../../../../services/rest-api.service';
import { ToastService } from '../../../custom/messaging/toast/toast.service';


@Component({
  selector: '[class="celerity-app"]',
  templateUrl: './signup.component.html'
})
export class SignupComponent implements OnInit {
  user: BasicUser;
  password1: string;
  password2: string;
  confirmAllowed = false;
  passwordMessage = '';
  agency = {} as BasicAgency;
  upper = /[A-Z]+/;
  lower = /[a-z]+/;
  num = /[0-9]+/;
  private confirmationKey;

  constructor(private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService,
              private rest: RestApiService, private patient: PatientService, private navigator: NavigatorService,
              private toast: ToastService) {}

   async ngOnInit() {
    try{
      await this.spinner.show();
      // Definitely don't want to be signed in while confirming a new account
      const session = await Auth.currentSession();
      if (session.isValid()) {
        this.patient.currentPatient = null;
        await Auth.signOut();
      }
    }catch (err){
      if (err !== 'No current user') this.toast.showDanger(err);
    }
    this.confirmationKey = this.route.snapshot.paramMap.get('confirmationKey');
    this.agency = this.patient.currentAgency;

    try{
      // Lookup the basics user info (name, email) for the supplied confirmation key
      this.user = await this.rest.confirmAccountInfo(this.confirmationKey);
      await this.spinner.hide();
    }catch(err){
      await this.spinner.hide();
      // On failure, e.g. key was wrong or already used, redirect to login
      console.warn(this.rest.errorMessage(err));
      return  this.router.navigateByUrl('/auth/landing');
    }
  }

  checkConfirm(event?: KeyboardEvent) {
    this.passwordMessage = '';
    if (this.password1 !== this.password2)
      this.passwordMessage = 'Passwords do not match';
    if (this.password1.length < 10)
      this.passwordMessage = 'Password must be at least 10 characters';
    if (!this.upper.test(this.password1) || !this.lower.test(this.password1) || !this.num.test(this.password1))
      this.passwordMessage = 'Password must contain an upper-case character, a lower-case character, and a number';
    this.confirmAllowed = !this.passwordMessage;
    if (event && this.confirmAllowed && event.key === 'Enter')
      this.confirmAccount();
  }

  async confirmAccount() {
    try {
      await this.spinner.show();
      const result = await this.rest.confirmAccount(this.confirmationKey);
      const response = await Auth.signIn(this.user.email,
        result.cognitoAccountCreated ? this.confirmationKey : this.password1
      );
      console.log(response);
      if (
        response.challengeName &&
        response.challengeName === 'NEW_PASSWORD_REQUIRED'
      ) {
        await Auth.completeNewPassword(response, this.password1, {});
      }
      this.patient.currentPatient = await this.rest.currentPatientData();
      await this.spinner.hide();
      return this.navigator.redirectToHomePage(this.patient.currentPatient);
    } catch (err) {
      await this.spinner.hide();
      this.toast.showDanger("Error!  Account confirmation failed.");
      console.log(this.rest.errorMessage(err));
    }
  }
}
